import { Controller } from "stimulus";
import Rails from "@rails/ujs";
import { openModal } from "../../util/modal";

export default class extends Controller {
  static targets = [
    "label",
    "textField",
    "editLink",
    "submitLink",
    "cancelLink",
    "commission",
    "bundleCommission",
    "nnnCommission",
    "nnnPlusThreeCommission",
    "nnnPlusSixCommission",
    "nnnPlusNineCommission",
    "nnnPlusTwelveCommission",
    "nxagPlusThreeCommission",
    "nxagPlusSixCommission",
    "nxagPlusNineCommission",
    "nxagPlusTwelveCommission",
    "nptPlusThreeCommission",
    "nptPlusSixCommission",
    "nptPlusNineCommission",
    "nptPlusTwelveCommission",
    "npdPlusThreeCommission",
    "npdPlusSixCommission",
    "npdPlusNineCommission",
    "npdPlusTwelveCommission",
    "nvmCommission",
    "nlpCommission"
  ];

  onChangeParentBtnClicked(e) {
    e.preventDefault();
    this.openChangeParentModal();
  }

  openChangeParentModal() {
    openModal({
      url: `/admin/partners/${this.element.dataset.id}/change_parent`,
      modalClass: "modal-lg"
    });
  }

  showForm(e) {
    if (e) e.preventDefault();
    this.editLinkTarget.classList.add("d-none");
    this.submitLinkTarget.classList.remove("d-none");
    this.cancelLinkTarget.classList.remove("d-none");
    this.element.querySelectorAll(".invalid-feedback").forEach(t => {
      t.classList.remove("d-none");
    });

    this.element.classList.add("editing");
    this.textFieldTargets.forEach(t => {
      t.classList.remove("d-none");
    });

    this.labelTargets.forEach(t => {
      t.classList.add("d-none");
    });
  }

  hideForm(e) {
    e.preventDefault();
    this.editLinkTarget.classList.remove("d-none");
    this.submitLinkTarget.classList.add("d-none");
    this.cancelLinkTarget.classList.add("d-none");
    this.element.querySelectorAll(".invalid-feedback").forEach(t => {
      t.classList.add("d-none");
    });

    this.element.classList.remove("editing");
    this.textFieldTargets.forEach(t => {
      t.classList.add("d-none");
    });

    this.labelTargets.forEach(t => {
      t.classList.remove("d-none");
    });
  }

  async updateDeactivated(e) {
    e.preventDefault();
    const data = new FormData();
    const partnerId = e.target.closest("tr").getAttribute("data-id");
    const link = "/admin/partners/" + partnerId + "/deactivate_user";
    data.append("partner[deactivated]", e.target.checked);
    Rails.ajax({
      type: "post",
      url: link,
      data
    });
  }

  async submit(e) {
    e.preventDefault();

    const data = new FormData();
    data.append("partner[commission]", this.commissionTarget.value);
    data.append(
      "partner[bundle_commission]",
      this.bundleCommissionTarget.value
    );
    data.append("partner[nnn_commission]", this.nnnCommissionTarget.value);
    data.append("partner[nnn_plus_three_commission]", this.nnnPlusThreeCommissionTarget.value);
    data.append("partner[nnn_plus_six_commission]", this.nnnPlusSixCommissionTarget.value);
    data.append("partner[nnn_plus_nine_commission]", this.nnnPlusNineCommissionTarget.value);
    data.append("partner[nnn_plus_twelve_commission]", this.nnnPlusTwelveCommissionTarget.value);
    data.append("partner[nxag_plus_three_commission]", this.nxagPlusThreeCommissionTarget.value);
    data.append("partner[nxag_plus_six_commission]", this.nxagPlusSixCommissionTarget.value);
    data.append("partner[nxag_plus_nine_commission]", this.nxagPlusNineCommissionTarget.value);
    data.append("partner[nxag_plus_twelve_commission]", this.nxagPlusTwelveCommissionTarget.value);
    data.append("partner[npt_plus_three_commission]", this.nptPlusThreeCommissionTarget.value);
    data.append("partner[npt_plus_six_commission]", this.nptPlusSixCommissionTarget.value);
    data.append("partner[npt_plus_nine_commission]", this.nptPlusNineCommissionTarget.value);
    data.append("partner[npt_plus_twelve_commission]", this.nptPlusTwelveCommissionTarget.value);
    data.append("partner[npd_plus_three_commission]", this.npdPlusThreeCommissionTarget.value);
    data.append("partner[npd_plus_six_commission]", this.npdPlusSixCommissionTarget.value);
    data.append("partner[npd_plus_nine_commission]", this.npdPlusNineCommissionTarget.value);
    data.append("partner[npd_plus_twelve_commission]", this.npdPlusTwelveCommissionTarget.value);
    data.append("partner[nvm_commission]", this.nvmCommissionTarget.value);
    data.append("partner[nlp_commission]", this.nlpCommissionTarget.value);

    Rails.ajax({
      type: "put",
      url: this.data.get("url"),
      data,
      success: (response, status, xhr) => {
        // @rails/ujs does DOM parsing in the background, which we don't like because it strips the <tr> out of the HTML
        this.element.innerHTML = xhr.responseText;
        this.element.classList.remove("editing");
      },
      error: (response, status, xhr) => {
        this.element.innerHTML = xhr.responseText;
        this.showForm();
      }
    });
  }
}
